// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d00fef99","279":"9d1d8a1c","350":"a43caa12","360":"ea5cd95d","453":"1407b060","684":"791c60ac"}[chunkId] + ".chunk.js";
};